import { GlobalDataService } from '../../../services/globalData.service'
import { IGlobalDataDoc } from '../../../services/globalIndexDb.service'

export class GlobalOptionsService extends GlobalDataService {
  public STANDARD_RULES = 'validation_application'
  public XSD_RULES = 'validation_nemsis_xsd'
  public RULES_UTILS = 'rules_util_js'
  public FILLABLE_PDF_BINDINGS = 'now_pcr_field_lookup'

  async getStandardRules(): Promise<IGlobalDataDoc | undefined | null> {
    return await this.getDocument(this.STANDARD_RULES)
  }

  async getXsdRules(): Promise<IGlobalDataDoc | undefined | null> {
    return await this.getDocument(this.XSD_RULES)
  }

  async getRulesUtils(): Promise<IGlobalDataDoc | undefined | null> {
    return await this.getDocument(this.RULES_UTILS)
  }

  async getFillablePDFBindings(): Promise<IGlobalDataDoc | undefined | null> {
    return await this.getDocument(this.FILLABLE_PDF_BINDINGS)
  }
}
